function findVideos() {
	var videos = document.querySelectorAll('.video');

	for (var i = 0; i < videos.length; i++) {
		setupVideo(videos[i]);
	}
}

function setupVideo(video) {
	var link = video.querySelector('.video__link');
    var button = video.querySelector('.video__button');
    var id = video.dataset.videoid;
    var start = '';
    var startTime = video.dataset.starttime;
    if (startTime) {
        start = startTime;
    }

	video.addEventListener('click', function() {
		var iframe = createIframe(id,start);

		link.remove();
		button.remove();
		video.appendChild(iframe);
	});
	link.removeAttribute('href');
	video.classList.add('video--enabled');
}

function createIframe(id,start) {
	var iframe = document.createElement('iframe');

	iframe.setAttribute('allowfullscreen', '');
	iframe.setAttribute('allow', 'autoplay');
	iframe.setAttribute('src', generateURL(id,start));
	iframe.classList.add('video__media');

	return iframe;
}

function generateURL(id,start) {
    if (start) {
        var query = '?rel=0&start='+ start +'&showinfo=0&autoplay=1';
    } else {
        var query = '?rel=0&showinfo=0&autoplay=1';
    }

	return 'https://www.youtube.com/embed/' + id + query;
}

$(function() {
    findVideos();
});